<figure class="m-0">
  <figcaption *ngIf="title" class="fw-semibold mb-2 text-center">{{ title }}</figcaption>
  <p class="visually-hidden">
    <ng-container *ngIf="label">{{ label }}: </ng-container>{{ value }}{{ unit
    }}<ng-container *ngIf="min !== max">, range {{ min }} to {{ max }}</ng-container>
  </p>
  <div #chartTarget style="width: 100%; height: 280px" aria-hidden="true"></div>
</figure>
